import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconExpand';
/** Renders an SVG icon. */
const SvgExpand = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M28 10a1 1 0 1 1-2 0V7.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L24.586 6H22a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1zM9.827 21.26a1 1 0 0 1 1.346 1.48L7.587 26H10a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1v-5a1 1 0 1 1 2 0v2.738zM28 22a1 1 0 1 0-2 0v2.586l-3.293-3.293a1 1 0 1 0-1.414 1.414L24.586 26H22a1 1 0 1 0 0 2h5a1 1 0 0 0 1-1zM9.293 10.707a1 1 0 1 0 1.414-1.414L7.414 6H10a1 1 0 1 0 0-2H5a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0V7.414zM14 14v4h4v-4zm6 4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2z"
      />
    </svg>
  );
};
SvgExpand.displayName = displayName;
export default SvgExpand;
